// extracted by mini-css-extract-plugin
module.exports = {"file":"File_file__10Wi5","fileBtn":"File_fileBtn__1sucU","closeBtn":"File_closeBtn__3SJDi","fileSelected":"File_fileSelected__1j_Pw","disabled":"File_disabled__2lC8o"};